import { render, staticRenderFns } from "./RecipientsView.vue?vue&type=template&id=76462528"
import script from "./RecipientsView.vue?vue&type=script&lang=js"
export * from "./RecipientsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports